import { Component, OnInit } from '@angular/core';
import { ImagesService } from '../images.service';
import { AlertConfirmable } from 'src/app/decorators/alert-confirmable.decorator';
import { ToastrService } from 'ngx-toastr';

export interface IPhotoBatch {
    id: number;
    createdAt: string;
    closedAt: string;
    winnerId: number;
}

export interface ICustomerPhoto {
    id: number;
    email: string;
    firstname: string;
    surname: string;
    url: string;
    isWinner: '0' | '1';
}

@Component({
    selector: 'app-user-photo-submissions',
    templateUrl: './user-photo-submissions.component.html',
    styleUrls: ['./user-photo-submissions.component.scss'],
})
export class UserPhotoSubmissionsComponent implements OnInit {
    batches: IPhotoBatch[] = [];
    selectedBatch: IPhotoBatch = null;
    photos: ICustomerPhoto[] = [];
    isLoading = false;
    veiwingPhotoIndex: number = null;

    constructor(private imagesService: ImagesService, private toastrService: ToastrService) {}

    ngOnInit(): void {
        this.imagesService.getPhotoBatches().subscribe((batches) => {
            this.batches = batches as any;
            this.selectedBatch = this.batches.find((b) => b.winnerId === null);
            if (this.selectedBatch) {
                this.getPhotos(this.selectedBatch.id);
            }
        });
    }

    getPhotos(selectedBatchId) {
        this.isLoading = true;
        this.imagesService.getPhotosFromBatch(selectedBatchId).subscribe((photos) => {
            this.photos = photos;
            this.isLoading = false;
        });
    }

    winnerSelected(photo: ICustomerPhoto) {
        if (!this.selectedBatch.winnerId) {
            this.setWinner(photo);
        }
    }

    @AlertConfirmable({ title: 'Do you want to set this photo as winner?' })
    setWinner(photo: ICustomerPhoto) {
        this.imagesService.setWinner(this.selectedBatch.id, photo.id).subscribe(() => {
            photo.isWinner = '1';
            this.selectedBatch.winnerId = photo.id;
            this.toastrService.success(`Photo created by ${photo.firstname} ${photo.surname} was set as winner`);
        });
    }

    viewPhoto(photoIndex: number) {
        this.veiwingPhotoIndex = photoIndex;
    }

    veiwerClosed() {
        this.veiwingPhotoIndex = null;
    }

    photosFlipped(veiwingPhotoIndex) {
        this.veiwingPhotoIndex = veiwingPhotoIndex;
    }
}
